import axios from 'axios';
import { serverUrl } from '../../ApiRoute';

/**
 * Connection status of one device from the MQTT broker.
 *
 * Unlike `mqttConnectionStatus` in common/ApiCall this does not toast on
 * failure — the page checks every device on a property at once, so errors are
 * returned and shown on the row instead.
 */
export const fetchConnectionStatus = async (deviceId) => {
  try {
    const res = await axios.post(`${serverUrl.mqttConnectionStatus}/connectionStatus`, { deviceId });
    if (res?.data?.success) {
      return { success: true, data: res.data.data || {} };
    }
    return { success: false, message: res?.data?.message || 'Could not fetch status' };
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || error?.message || 'Something went wrong',
    };
  }
};
